import { LoadingButton, LoadingButtonProps } from "@mui/lab";

const Button = ({
  size,
  loading = false,
  className,
  color,
  children,
  variant = "contained",
  onClick,
  disabled,
  loadingPosition = "start",
  endIcon,
  startIcon,
  style,
  fullWidth = false,
}: LoadingButtonProps) => {
  return (
    <LoadingButton
      centerRipple={true}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      loadingPosition={loadingPosition}
      variant={variant}
      className={className}
      fullWidth={fullWidth}
      size={size}
      color={color}
      sx={{ textTransform: "none" }}
      endIcon={endIcon}
      startIcon={startIcon}
      style={{
        borderWidth: "1px",
        padding: "8px 16px",
        ...style,
      }}
    >
      {children}
    </LoadingButton>
  );
};

export default Button;
